import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { SubscriptionProvider } from './contexts/SubscriptionContext'
import { LandingPage } from './pages/LandingPage'
import { ChatPage } from './pages/ChatPage'
import { AccountSettings } from './pages/AccountSettings'
import { PasswordReset } from './pages/PasswordReset'
import { SetPassword } from './pages/SetPassword'
import { PaymentSuccess } from './pages/PaymentSuccess'
import { PaymentCanceled } from './pages/PaymentCanceled'
import { AdminDashboard } from './pages/AdminDashboard'
import { PrivacyPolicy } from './pages/PrivacyPolicy'
import { TermsOfService } from './pages/TermsOfService'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <SubscriptionProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/signup" element={<LandingPage />} />
            <Route path="/signin" element={<LandingPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/account-settings" element={<AccountSettings />} />
            <Route path="/reset-password" element={<PasswordReset />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-canceled" element={<PaymentCanceled />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </Router>
      </SubscriptionProvider>
    </AuthProvider>
  </React.StrictMode>,
)